import React, { useEffect, useState, useRef } from 'react';
import BreadCrumbComponent from '../bread-crumb/BreadCrumbComponent';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin, appInsights } from '../../AppInsights';
import { withMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import Spinner from "../Spinner"
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Tooltip } from 'primereact/tooltip';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { MessageSeverity } from 'primereact/api';
import { IACLService } from '../IACL/IACLService';
import { ExportFileService } from '../../services/ExportFileService'
import { ProdItemSettingService } from '../prodItemSettings/ProdItemSettingSerivce'
import "./Report.css";

//HDO-7006 - Monitoring Tool - Interface Count Report - Implementation
function IntefaceTracker(props) {
  const iaclService = new IACLService();
  const exportFileService = new ExportFileService();
  const prodItemSettingService = new ProdItemSettingService();
  const alertMessage = useRef(null);
  const [hideSpinner, sethideSpinner] = useState(false);
  const [hieSystem, sethieSystem] = useState([]);
  const [namespaceList, setNamespaceList] = useState([]);
  const [interfaceTrackerData, setInterfaceTrackerData] = useState([]);
  const [pageErrorMessage, setpageErrorMessage] = useState(null)
  const [pageSuccessMessage, setpageSuccessMessage] = useState(null)
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
  });
  const getLastDayPreviousMonth = () => {
    const today = new Date();
    const firstDayCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return new Date(firstDayCurrentMonth - 1);
  };
  const [searchRequest, setSearchRequest] = useState({
    'CreatedDateFrom': sessionStorage.getItem("CreatedDateFrom") ? new Date(sessionStorage.getItem("CreatedDateFrom")) : getLastDayPreviousMonth(),
    'NameSpace': sessionStorage.getItem("NameSpace") ? JSON.parse(sessionStorage.getItem("NameSpace")) : ''
  })

  useEffect(() => {
    getProductions(['ALL'])
  }, [])

  const getProductions = (instance) => {
    sethideSpinner(false); setpageErrorMessage(null); setpageSuccessMessage(null)
    prodItemSettingService.getProductions(instance, props.msalContext).then(
      (d) => {
        if (d.status === 403) {
          setpageErrorMessage('You do not have permission to view this page.'); sethideSpinner(true);
        } else {
          let namespace = []
          d.body.map((item) => (namespace.push({ label: item.Namespace, value: item.Namespace })));
          setNamespaceList(namespace); sethideSpinner(true); loadIACLData();
        }
      }
    ).catch(e => {
      console.log(e)
      setpageErrorMessage('Something went wrong !'); sethideSpinner(true);
    });
  }

  const loadIACLData = () => {
    sethideSpinner(false);
    let payload = {
      Namespace: '' + searchRequest.NameSpace + '',
      CreatedDateFrom: searchRequest.CreatedDateFrom ? searchRequest.CreatedDateFrom : '',
      OnboardTracker: true,
    }
    iaclService.getIACLHomeData(JSON.stringify(payload), props.msalContext).then(response => {
      if (response && response.status === 200) {
        setInterfaceTrackerData(response.body)
        sethideSpinner(true)
      }
      else {
        sethideSpinner(true)
        setpageErrorMessage("Something went wrong !!!")
      }
    }).catch(e => {
      console.log(e)
      setpageErrorMessage('Something went wrong !'); sethideSpinner(true);
    })
  }

  const exportInboundData = () => {
    const interfaceTrackerDataExport = interfaceTrackerData.map(item => {
      return {
        'Namespace': item.NameSpace,
        'Interface': item.Interface,
        'Created Date': item.CreatedDateDisplay,
        'Created By': item.CreatedBy
      }
    });
    exportFileService.exportExcel(interfaceTrackerDataExport, 'interface-tracker');
    setpageErrorMessage(null); setpageSuccessMessage("File exported successfully !!!");
  }

  const globalSearchFilter = () => {
    return (
      <div>
        <div className="flex justify-content-between" >
          <span>
            <Button type="button" icon="pi pi-file-export" label="Export" className="p-button-success" tooltip='Export into excel' tooltipOptions={{ position: 'top' }} onClick={exportInboundData} />
          </span>
          <span className="p-input-icon-left">
            <i className="pi pi-search"></i>
            <InputText type="search" value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" style={{ width: '100%' }} size={100} />
          </span>
          <span>
            <Button tooltip='Refresh' tooltipOptions={{ position: 'top' }} onClick={(e) => loadIACLData()} icon="pi pi-refresh" />
          </span>
        </div>
      </div>
    )
  }

  const onGlobalFilterChange = (e) => {
    setpageErrorMessage(null); setpageSuccessMessage(null);
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters); setGlobalFilterValue(value);
  }

  const handleMultiDropDownInputChange = (event) => {
    sessionStorage.setItem([event.target.name], JSON.stringify(event.value));
    setpageErrorMessage(null); setpageSuccessMessage(null);
    setSearchRequest(prev => ({
      ...prev,
      [event.target.name]: event.value
    }));
  }

  const handleInputChange = (event) => {
    setpageErrorMessage(null); setpageSuccessMessage(null);
    sessionStorage.setItem([event.target.name], event.target.value);
    setSearchRequest(prev => ({
      ...prev,
      [event.target.name]: event.target.value
    }));
  }

  const clearSearchParams = () => {
    setSearchRequest({
      'NameSpace': '',
      'CreatedDateFrom': getLastDayPreviousMonth()
    });
    setpageErrorMessage(null); setpageSuccessMessage(null);
    setFilters({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    setGlobalFilterValue('');
    sessionStorage.clear();
  }

  const showError = (severity, summary, msg) => {
    alertMessage.current.show({ severity: severity, summary: summary, detail: msg, life: global.ALERT_MSG_LIFE });
  }

  const tooltipItems = [
    "Displays interface onboarding dates based on records created in IACL (Interoperability Ancillary Calling List) by development and operations teams"
  ];

  // Join items with <br /> for line breaks in the tooltip
  const tooltipContent = tooltipItems.join('\n');

  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
      <div>
        <BreadCrumbComponent {...props} />
        <Toast ref={alertMessage} />
        {pageErrorMessage ? showError(MessageSeverity.ERROR, 'Error Message', pageErrorMessage) : <></>}
        {pageSuccessMessage ? showError(MessageSeverity.SUCCESS, 'Success Message', pageSuccessMessage) : <></>}

        <div hidden={hideSpinner}>
          <Spinner />
        </div>

        <header className="page-header">
          <div className="page-header-title">INTERFACE TRACKER
            &nbsp;<Tooltip target=".custom-target-icon" content={tooltipContent} />
            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
              style={{ fontSize: '1rem', cursor: 'pointer' }}>
            </i>
          </div>
        </header>

        <div className="card">
          <div className="float-container">
            <div className="float-child">
              <label htmlFor="basic"><b>Namespace:</b></label>
              <MultiSelect options={namespaceList} value={searchRequest.NameSpace} name='NameSpace'
                filter onChange={(e) => handleMultiDropDownInputChange(e)} maxSelectedLabels={1} placeholder="--Select--" className="multiselect-custom"
              />
            </div>
            <div className="float-child">
              <label htmlFor="basic"><b>From Date:</b></label>
              <Calendar id="basic" name='CreatedDateFrom' value={searchRequest.CreatedDateFrom} onChange={(e) => handleInputChange(e)}></Calendar>
            </div>
            <div className="float-child">
              <label htmlFor="basic"><br></br></label>
              <Button label='Search' onClick={(e) => loadIACLData()} />
            </div>
            <div className="float-child">
              <label htmlFor="basic"><br></br></label>
              <Button label='Clear' onClick={clearSearchParams} />
            </div>
          </div>
        </div>

        <DataTable value={interfaceTrackerData}
          dataKey="Id"
          paginator={true}
          rows={10}
          rowsPerPageOptions={[10, 20, 50, 100]}
          selectionMode="single"
          responsiveLayout="scroll"
          responsive={true}
          emptyMessage="No Records found."
          showGridlines={true}
          filters={filters}
          header={globalSearchFilter}
          stateStorage="session" stateKey="dt-interfaceOnboardTracker-session"
        >
          <Column field="NameSpace" header="Namespace" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} />
          <Column field="Interface" header="Interface" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} />
          <Column field="CreatedDateDisplay" header="Created Date" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} sortable sortField='CreatedDate' />
          <Column field="CreatedBy" header="Created By" alignHeader='center' style={{ textAlign: 'center', width: '160px' }} />
        </DataTable> <br />
      </div>
    </MsalAuthenticationTemplate>
  );
}

const WrappedIntefaceTracker = withMsal(IntefaceTracker);
export default withAITracking(reactPlugin, WrappedIntefaceTracker);